import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize
} from '@dboxdev/ui-components'
import CheckboxIcon from 'icons/checkbox.svg'

export const Label = styled.label`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${calculateResponsiveSize(16)};
  cursor: pointer;
  ${mediaMax('mobile')} {
    gap: ${calculateResponsiveSize(6)};
  }
`

export const Title = styled.div``

export const GroupItem = styled.div`
  display: inline-block;
  &:not(:last-child) {
    margin-right: ${calculateResponsiveSize(20)};
  }
`

export const InputWrap = styled.div`
  position: relative;
  display: block;
  flex-shrink: 0;
  cursor: pointer;
`

export const Input = styled.input`
  position: absolute;
  width: 0;
  overflow: hidden;
  visibility: hidden;
`

export const Wrap = styled.div`
  display: flex;
  span {
    display: block;
    width: ${calculateResponsiveSize(14)};
    height: ${calculateResponsiveSize(14)};
    background: url(${CheckboxIcon}) top center no-repeat;
    background-size: ${calculateResponsiveSize(14)} auto;
    position: relative;
    top: ${calculateResponsiveSize(3)};
  }
  ${Input}:checked + span {
    background-position: bottom center;
  }
  ${mediaMax('mobile')} {
    span {
      width: ${calculateResponsiveSize(10)};
      height: ${calculateResponsiveSize(10)};
      background-size: ${calculateResponsiveSize(10)} auto;
      top: ${calculateResponsiveSize(1)};
    }
  }
`
